export default __webpack_public_path__ + "static/media/icon_cross_cancel.f13a0b9c.gif";